import { useTranslation } from 'react-i18next';

import { DraftPlot, PlotType } from '@/api/rest/resources/types/plot';
import { Logger } from '@/lib/logs/logger';

import { DEFAULT_MANUAL_PLOT_NAME, extractServerError, parseLatLng, UNKNOWN_ERROR_KEY } from '../utils';
import { useCreateDraftPlotFromCoordinates } from './useDraftPlotUploadActions';

type ManualPlotCallbacks = {
  organizationId: string | null;
  onSuccess: (createdPlot: DraftPlot) => void;
  onError: (message: string) => void;
};

export const useManualPlotSubmit = ({ organizationId, onSuccess, onError }: ManualPlotCallbacks) => {
  const { t } = useTranslation();
  const { submit: saveCoordinates, isSubmitting } = useCreateDraftPlotFromCoordinates();

  const submit = async (params: { name: string; lat: string; lng: string; landType: PlotType | '' }) => {
    const coords = parseLatLng(params.lat, params.lng);
    if (!coords) {
      onError(t('shared.uploadCoordinates.error.invalidCoords'));
      return;
    }
    try {
      const createdPlot = await saveCoordinates({
        name: params.name || DEFAULT_MANUAL_PLOT_NAME,
        latitude: coords.lat,
        longitude: coords.lng,
        land_type: params.landType as PlotType,
        organization: organizationId ?? undefined,
      });
      onSuccess(createdPlot);
    } catch (error) {
      onError(extractServerError(error, t(UNKNOWN_ERROR_KEY)));
      Logger.errorOnce(error as Error);
    }
  };

  return { submit, isSubmitting };
};
